<template>
  <v-card>
    <v-toolbar
      v-if="title"
      color="secondary"
      dark
      dense
      flat
    >
      <v-spacer />
      <v-toolbar-title v-text="title" />
      <v-spacer />
    </v-toolbar>

    <v-card-text>
      <bar-chart
        style="height: 300px"
        :data="data"
        :datasets="datasets"
        data-key="playerName"
        :average="$t('general.average')"
        :step-size="stepSize"
        :suggested-max="suggestedMax"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import BarChart from './BarChart'

export default {
  name: 'BarChartCard',
  components: {
    BarChart,
  },
  props: {
    game: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    indicator: {
      type: String,
      required: true,
      validator: value => ['timePlayed', 'numberOfMistakes'].includes(value),
    },
    sequential: {
      type: Boolean,
      default: false,
    },
    stepSize: {
      type: Number,
      default: 1,
    },
    suggestedMax: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    data () {
      return this.game.playerList
        .filter(player => player.playerName && player.status === 'finished')
    },
    parallelDataset () {
      return {
        label: this.$t('animation.menu.games.multiTaskParallel'),
        backgroundColor: 'rgba(45, 86, 109, 0.8)',
        borderColor: 'rgb(45, 86, 109)',
        pointBackgroundColor: 'rgb(45, 86, 109)',
      }
    },
    sequentialDataset () {
      return {
        label: this.$t('animation.menu.games.multiTaskSequential'),
        backgroundColor: 'rgba(138, 62, 112, 0.8)',
        borderColor: 'rgb(138, 62, 112)',
        pointBackgroundColor: 'rgb(138, 62, 112)',
      }
    },
    datasets () {
      const datasets = { [`parallel.${this.indicator}`]: this.parallelDataset }

      if (this.sequential) {
        datasets[`sequential.${this.indicator}`] = this.sequentialDataset
      }

      return datasets
    },
  },
}
</script>
